<p-toast></p-toast>

<app-page-shell>

    <app-page-hero
        eyebrow="Fleet Assets"
        [title]="title()"
        subtitle="Create or update a trailer as a uniquely identified fleet asset.">
        <div actions>
            <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="cancel()"></p-button>
            <p-button label="Save" icon="pi pi-save" [loading]="isSaving" (onClick)="save()"></p-button>
        </div>
    </app-page-hero>

    <form [formGroup]="form" class="form-grid">
        <div>
            <app-page-form-section icon="pi pi-ticket" title="Asset Identity" subtitle="Identify the trailer and classify it by trailer type.">
                <div class="field-grid">
                    <div class="field">
                        <label for="assetNumber">Asset Number</label>
                        <input id="assetNumber" pInputText formControlName="assetNumber" placeholder="TRL-0001" />
                    </div>
                    <div class="field">
                        <label for="trailerType">Trailer Type</label>
                        <p-select inputId="trailerType" [options]="trailerTypes" formControlName="trailerType" optionLabel="name"
                            [filter]="true" filterBy="code,name" appendTo="body" placeholder="Select trailer type" styleClass="w-full">
                            <ng-template pTemplate="item" let-trailerType>
                                <div class="stacked-cell">
                                    <span>{{ trailerType.name }}</span>
                                    <small>{{ trailerType.code }}</small>
                                </div>
                            </ng-template>
                        </p-select>
                    </div>
                    <div class="field">
                        <label for="status">Status</label>
                        <p-select inputId="status" [options]="statusOptions" formControlName="status" optionLabel="label" optionValue="value" styleClass="w-full"></p-select>
                    </div>
                    <div class="field">
                        <label for="active">Active</label>
                        <p-select inputId="active" [options]="activeOptions" formControlName="active" optionLabel="label" optionValue="value" styleClass="w-full"></p-select>
                    </div>
                </div>
            </app-page-form-section>

            <app-page-form-section icon="pi pi-file" title="Registration" subtitle="Optional plate, registration, and expiry data.">
                <div class="field-grid">
                    <div class="field">
                        <label for="plateNumber">Plate Number</label>
                        <input id="plateNumber" pInputText formControlName="plateNumber" placeholder="Plate number" />
                    </div>
                    <div class="field">
                        <label for="registrationNumber">Registration Number</label>
                        <input id="registrationNumber" pInputText formControlName="registrationNumber" placeholder="Registration number" />
                    </div>
                    <div class="field">
                        <label for="registrationExpiry">Registration Expiry</label>
                        <p-datePicker inputId="registrationExpiry" formControlName="registrationExpiry" dateFormat="yy-mm-dd" appendTo="body" styleClass="w-full"></p-datePicker>
                    </div>
                    <div class="field">
                        <label for="insuranceExpiry">Insurance Expiry</label>
                        <p-datePicker inputId="insuranceExpiry" formControlName="insuranceExpiry" dateFormat="yy-mm-dd" appendTo="body" styleClass="w-full"></p-datePicker>
                    </div>
                    <div class="field" style="grid-column: 1 / -1;">
                        <label for="notes">Notes</label>
                        <textarea id="notes" pTextarea formControlName="notes" rows="4" placeholder="Operational notes"></textarea>
                    </div>
                </div>
            </app-page-form-section>
        </div>

        <aside class="summary-panel">
            <h2>Summary</h2>
            <div class="summary-row">
                <span>Asset</span>
                <strong>{{ form.value.assetNumber || '-' }}</strong>
            </div>
            <div class="summary-row">
                <span>Type</span>
                <strong>{{ selectedTrailerTypeName() }}</strong>
            </div>
            <div class="summary-row">
                <span>Status</span>
                <strong>{{ form.value.status || '-' }}</strong>
            </div>
            <div class="summary-row">
                <span>Active</span>
                <strong>{{ form.value.active === false ? 'Inactive' : 'Active' }}</strong>
            </div>
        </aside>
    </form>
</app-page-shell>
